import { t } from "i18next";
import React from "react";

const NoDataMessage = ({ message = t("properties.no_data_found"), icon = "bx-error-circle", color = "red", size = '50px' }) => {
    return (
        <div className="d-flex flex-column justify-content-center align-items-center">
            <i className={`bx ${icon}`} style={{ fontSize: size, color: color }}></i>
            <p className="text-danger h2">{message}</p>
        </div>
    );
};

export default NoDataMessage;
